<template>
  <div>
    <div class="container">
      <TextArea
        class="child"
        :textTitle="endpointName"
        :textLinesArray="endpointDesc"
      ></TextArea>
      <EndpointCard
        class="child"
        cardTitle="ENDPOINTS"
        :endpoints="endpoints"
      />
    </div>
    <div :ref="endpoints[0].ref" class="container">
      <Attribute
        class="child"
        :attributes="attributes"
        :endpoint="responseTitle"
      />
      <ResponseCard
        class="child"
        :response="response"
        :cardTitle="responseCodeTitle"
      />
    </div>
    <div ref="POST" class="container">
      <div class="child">
        <TextArea :textTitle="postTitle" :textLinesArray="postDesc"></TextArea>
        <div>
          <Attribute :attributes="postAttributes" endpoint="RolesDTO" />
        </div>
      </div>
      <div class="child">
        <PostExample
          :postExample="postExample"
          cardTitle="POST /api/v4.0/roles/user/:id"
        />
        <ResponseCard
          class="mt-5"
          :response="postResponse"
          cardTitle="RESPONSE."
        />
    </div>
    </div>
  </div>
</template>

<style scoped>
.postCard {
  max-height: 600px;
}

.container {
  display: flex;
  flex-flow: row wrap;
  padding-left: 10rem;
  padding-right: 10rem;
}

.child {
  min-width: 40%;
  max-width: 45%;
  flex-grow: 1;
  flex-shrink: 1;
}

@media screen and (max-width: 500px) {
  .container {
    flex-flow: column wrap;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .child {
    max-width: 380px;
    min-width: 300px;
  }
}
</style>

<script>
import EndpointCard from "../../../components/content/EndpointCard.vue";
import Attribute from "../../../components/request/Attribute.vue";
import TextArea from "../../../components/content/TextArea.vue";
import ResponseCard from "../../../components/request/ResponseCard.vue";
import PostExample from "../../../components/request/PostExample.vue";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
    PostExample,
  },
  created() {
    this.$root.$on("scrollToEndpoint", (ref) => {
      var element = this.$refs[ref];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    });
  },
  computed: {
    endpointName() {
      return this.$t("roles.endpointTitle");
    },
    filteringTitle() {
      return this.$t("roles.filteringTitle");
    },
    filteringText() {
      return this.$t("roles.filteringText");
    },
    endpointDesc() {
      return this.$t("roles.endpointDesc");
    },
    endpoints() {
      return this.$t("roles.controllerEndpoints");
    },
    responseTitle() {
      return this.$t("roles.getTitle");
    },
    responseCodeTitle() {
      return this.$t("roles.responseCodeTitle");
    },
    response() {
      return this.$t("roles.getResponse");
    },
    attributes() {
      return this.$t("roles.getAttributes");
    },
    postResponse() {
      return this.$t("roles.postResponse");
    },
    postAttributes() {
      return this.$t("roles.postAttributes_rolesDTO");
    },
    postExample() {
      return this.$t("roles.postExample");
    },
  },
};
</script>